import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import { ArticleFragment } from '@/features/editorial/graphql/queries/GetArticleByUrl.query';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideItemCondensed',
  props: {
    article: null,
    index: null
  },
  setup(__props: any) {

const props = __props as { article: ArticleFragment; index: number };



const articleImage = computed(() => {
	const backdropIndex = props.article.mainObjects[0].node.content.backdrops[props.index] ? props.index : 0;
	return !!mainImageEntityBackdrop.value
		? `https://www.justwatch.com/images${mainImageEntityBackdrop.value}`
		: props.article.mainObjects[0].node.content.backdrops[backdropIndex].backdropUrl;
});

const mainImageEntityBackdrop = computed(() => {
	return props.article?.content?.mainImageEntityBackdrop?.backdropUrl
		? props.article?.content?.mainImageEntityBackdrop?.backdropUrl
		: '';
});

const trimH1Tags = (string: string) => {
	return string.substring(4, string.length - 5);
};

const articleTitle = computed(() => {
	return trimH1Tags(props.article.content.title || '');
});

return { __sfc: true,props, articleImage, mainImageEntityBackdrop, trimH1Tags, articleTitle, PictureComp, faArrowRight }
}

})